import React, {
  useState,
  useRef,
  memo,
  forwardRef,
  useEffect,
  useImperativeHandle,
} from 'react';
import { Input } from 'antd';

const AgInputEditor = memo(
  forwardRef((props, ref) => {
    const [value, setValue] = useState(props.value);
    const refInput = useRef(null);

    useEffect(() => {
      refInput.current.focus();
    }, []);

    useImperativeHandle(ref, () => ({
      getValue() {
        return value;
      },

      // // Gets called once before editing starts, to give editor a chance to
      // // cancel the editing before it even starts.
      // isCancelBeforeStart() {
      //   return false;
      // },

      // // Gets called once when editing is finished (eg if Enter is pressed).
      // // If you return true, then the result of the edit will be ignored.
      // isCancelAfterEnd() {
      //   // our editor will reject any value greater than 1000
      //   return value > 1000;
      // },
    }));

    return (
      <Input
        ref={refInput}
        value={value}
        onChange={(event) => setValue(event.target.value)}
      />
    );
  }),
);

export default AgInputEditor;
